module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres78u"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres78uIndex,
      "searchBoxAlias": "approve",
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.approveEvent,
      "approveRowBool": true
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "detail": _vm.detail,
      "detailTab3Table": _vm.columns[_vm.dash.nowLang].detailTab3Table,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group-button"
  }, [_c('button', {
    ref: "approve",
    staticClass: "btn bg-blue",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres78u-popup-approve"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.btn_approve))])]), _vm._v(" "), _c('popup-approve', {
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "nowLang": _vm.dash.nowLang,
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "indexSelected": _vm.indexSelected,
      "postHres78uSendApprove": _vm.postHres78uSendApprove,
      "detail": _vm.detail,
      "detailSubmit": _vm.detailSubmit,
      "arrTypintr": _vm.dropdowns.typintr,
      "codappr": _vm.codempid,
      "descCodappr": _vm.dash.currentUser.username[_vm.dash.nowLang],
      "showTrailRepayment": _vm.showTrailRepayment,
      "showProcessTable": _vm.showProcessTable,
      "showPersonaldata": _vm.showPersonaldata,
      "setShowTrailRepayment": _vm.setShowTrailRepayment,
      "setShowProcessTable": _vm.setShowProcessTable,
      "setShowPersonaldata": _vm.setShowPersonaldata,
      "trailRepayment": _vm.trailRepayment,
      "columnsProcessTable": _vm.columns[_vm.dash.nowLang].columnsProcessTable,
      "tableProcess": _vm.tableProcess,
      "datapersonal": _vm.datapersonal,
      "receivedHres78uDetailSubmit": _vm.receivedHres78uDetailSubmit,
      "receivedHres78uPopupTrailRepayment": _vm.receivedHres78uPopupTrailRepayment,
      "receivedHres78uPopupProcessTable": _vm.receivedHres78uPopupProcessTable,
      "receivedHres78uPopupPersonaldata": _vm.receivedHres78uPopupPersonaldata,
      "searchParams": _vm.searchParams
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-594ac903!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres78u/component.vue
// module id = 3787
// module chunks = 1